var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.vClass},[_vm._t("loader-loop"),_vm._v(" "),_vm._t("block-loop")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }